import { useSelector } from '@common/performance/useSelector';
import { StableChildren } from '@prophecy/utils/react/StableChildren';
import { createContext } from 'react';

type UserSessionContextType = string | null;

export const UserSessionContext = createContext<UserSessionContextType>(null);

/**
 * Provider for the user session context - ensure store is available when wrapping your component with this provider
 */
export const UserSessionProvider = ({ children }: { children: React.ReactNode }) => {
  const sessionId = useSelector((state: { sessionId: string }) => state.sessionId);

  return (
    <UserSessionContext.Provider value={sessionId}>
      <StableChildren>{children}</StableChildren>
    </UserSessionContext.Provider>
  );
};
